module.exports = __webpack_public_path__ + "static/Medimage Lois-16-bc283c433fedd1b4fe8ccdd6c3ed3f51.jpg";